// Mock data for LM Digital - Web Design & Performance Agency
// Updated with unified CTAs - Agency voice ("Nous")
// Targeting TPE/PME

export const heroData = {
  badge: "CRÉATION & REFONTE DE SITES WEB",
  title: {
    line1: "Des sites web conçus pour",
    line2: "générer des demandes",
    highlight: "qualifiées"
  },
  subtitle: "pour les TPE et PME",
  description: "Nous concevons et refondons des sites web orientés conversion, pensés comme une base solide pour votre croissance digitale. Un site structuré, rapide et clair est un prérequis avant toute stratégie publicitaire efficace.",
  benefits: [
    { text: "Sites optimisés", highlight: "pour la conversion et l'expérience utilisateur" },
    { text: "Design professionnel", highlight: "aligné avec votre cible" },
    { text: "Base fiable", highlight: "pour vos futures campagnes publicitaires" }
  ],
  cta: "Planifier un échange stratégique",
  ctaSubtext: "20 minutes • Sans engagement • Création, refonte ou Ads"
};

export const problemsData = {
  badge: "LE CONSTAT",
  title: "Pourquoi de nombreux sites ne convertissent pas suffisamment",
  description: "Un site web obsolète ou mal structuré freine la prise de contact et réduit l'efficacité de toute action marketing.",
  challenges: [
    {
      icon: "Monitor",
      title: "Design vieillissant",
      text: "Un site qui ne reflète pas le professionnalisme de l'entreprise crée de la méfiance."
    },
    {
      icon: "Smartphone",
      title: "Non optimisé mobile",
      text: "Plus de 60 % du trafic est aujourd'hui mobile. Un site non responsive perd une part importante de ses visiteurs."
    },
    {
      icon: "Clock",
      title: "Temps de chargement lent",
      text: "Chaque seconde supplémentaire impacte directement le taux de conversion."
    },
    {
      icon: "MousePointer",
      title: "Parcours utilisateur confus",
      text: "Un message flou ou des appels à l'action peu visibles empêchent les visiteurs de passer à l'étape suivante."
    }
  ],
  cta: "Échanger sur votre situation actuelle"
};

export const methodData = {
  badge: "LA MÉTHODE",
  title: "Structurer le site avant d'amplifier avec les Ads",
  subtitle: "Une approche en 3 étapes",
  description: "Notre approche repose sur une logique simple : construire une base performante avant d'investir en publicité.",
  phases: [
    {
      number: "01",
      title: "Audit & diagnostic",
      subtitle: "Analyse de l'existant",
      description: "Analyse de l'existant, identification des points de friction, compréhension de vos objectifs business.",
      color: "blue",
      deliverables: ["Rapport clair", "Priorisation des actions"]
    },
    {
      number: "02", 
      title: "Création / Refonte",
      subtitle: "Orientée conversion",
      description: "Conception d'un site moderne, rapide et mobile-first. Optimisation UX, messages clairs, pages de conversion efficaces, outils de suivi configurés.",
      color: "teal",
      deliverables: ["Site moderne et rapide", "Optimisation UX", "Tracking configuré"]
    },
    {
      number: "03",
      title: "Amplification Ads",
      subtitle: "Étape optionnelle",
      description: "Une fois le site prêt à convertir, les campagnes publicitaires deviennent réellement rentables. Google Ads et Meta Ads pilotés sur des objectifs mesurables.",
      color: "slate",
      deliverables: ["Campagnes Google Ads", "Campagnes Meta Ads", "Objectifs mesurables"]
    }
  ],
  note: "Cette étape n'est proposée que lorsque le site est capable de transformer le trafic en opportunités réelles.",
  cta: "Définir la meilleure approche pour votre projet"
};

export const benchmarksData = {
  badge: "REPÈRES DE PERFORMANCE OBSERVÉS",
  title: "Ce qu'un site optimisé peut générer",
  description: "Ces chiffres sont des indicateurs observés, pas des garanties.",
  stats: [
    {
      value: "5-10%",
      label: "Taux de conversion",
      detail: "pour une landing page bien optimisée",
      comparison: "vs 1 à 2 % pour une page non optimisée",
      source: "Benchmarks marché"
    },
    {
      value: "+50 à +200%",
      label: "Augmentation du taux de conversion",
      detail: "passage d'un site non structuré à un site optimisé UX",
      comparison: "jusqu'à +400 % dans certains cas",
      source: "Études UX"
    },
    {
      value: "2-3%",
      label: "Taux de conversion moyen",
      detail: "pour un site web bien configuré",
      comparison: "toutes industries confondues",
      source: "Benchmarks 2025"
    }
  ],
  note: "Ces chiffres sont des indicateurs observés sur le marché, pas des garanties. Chaque situation est unique.",
  cta: "Évaluer votre potentiel de conversion"
};

export const whyFirstData = {
  badge: "POURQUOI CETTE APPROCHE",
  title: "La qualité du site conditionne la rentabilité des Ads",
  points: [
    {
      icon: "Target",
      title: "Éviter le gaspillage publicitaire",
      description: "Envoyer du trafic payant sur un site qui ne convertit pas, c'est augmenter le coût d'acquisition."
    },
    {
      icon: "Calculator",
      title: "Moins de visiteurs, plus de leads",
      description: "Plus un site convertit, moins il faut de visiteurs pour générer un lead."
    },
    {
      icon: "TrendingUp",
      title: "Des résultats durables",
      description: "Un site bien conçu continue de produire des résultats dans le temps, même sans publicité."
    }
  ],
  conclusion: "C'est pourquoi nous recommandons toujours de commencer par structurer le site avant d'investir en Ads.",
  cta: "Vérifier si votre site est prêt pour les Ads"
};

export const servicesData = {
  badge: "CE QUE NOUS PROPOSONS",
  title: "Nos prestations",
  services: [
    {
      icon: "PenTool",
      title: "Création de site web",
      description: "Sites vitrines professionnels, modernes et optimisés pour la conversion.",
      features: ["Design responsive", "Optimisation SEO de base", "Formulaires de contact", "Analytics configurés"]
    },
    {
      icon: "RefreshCw",
      title: "Refonte de site existant",
      description: "Modernisation, amélioration UX, performance et vitesse.",
      features: ["Audit de l'existant", "Nouveau design", "Migration du contenu", "Optimisation vitesse"]
    },
    {
      icon: "Rocket",
      title: "Landing pages",
      description: "Pages dédiées orientées conversion pour vos offres ou campagnes.",
      features: ["Design orienté conversion", "A/B testing ready", "Intégration CRM", "Tracking avancé"]
    },
    {
      icon: "BarChart2",
      title: "Stratégie Ads",
      description: "Google Ads et Meta Ads, pilotés sur des objectifs mesurables.",
      features: ["Google Ads (Search, Display)", "Meta Ads (Facebook, Instagram)", "Suivi des conversions", "Rapports mensuels"],
      badge: "Après optimisation site"
    }
  ],
  cta: "Parler de votre projet"
};

export const faqData = {
  badge: "QUESTIONS FRÉQUENTES",
  title: "Vos questions",
  questions: [
    {
      question: "Pourquoi ne pas commencer directement par les Ads ?",
      answer: "Les Ads génèrent du trafic, mais c'est le site qui convertit. Sans base solide, le budget publicitaire est sous-exploité."
    },
    {
      question: "Comment mesurez-vous les résultats ?",
      answer: "Nous mettons en place des outils de suivi permettant de mesurer les indicateurs clés : taux de conversion, formulaires, comportements utilisateurs."
    },
    {
      question: "Est-ce adapté à mon secteur d'activité ?",
      answer: "Nous accompagnons des TPE et PME de secteurs variés. L'approche est toujours adaptée à la cible et aux objectifs spécifiques."
    },
    {
      question: "Que comprend le premier échange ?",
      answer: "Un échange structuré de 20 minutes pour analyser votre site ou votre projet, identifier les freins et définir les axes d'amélioration prioritaires."
    }
  ],
  cta: "Planifier un échange stratégique"
};

export const ctaData = {
  badge: "PROCHAINE ÉTAPE",
  title: "Échangeons sur votre projet",
  subtitle: "20 minutes pour définir la meilleure approche",
  description: "Un échange clair pour comprendre votre situation, vos objectifs, et identifier les leviers de conversion les plus pertinents — que ce soit pour une création de site, une refonte ou une stratégie Ads.",
  benefits: [
    "Analyse de votre situation actuelle",
    "Identification des axes prioritaires",
    "Recommandations adaptées à votre projet",
    "Sans engagement"
  ],
  cta: "Planifier un échange stratégique",
  ctaSubtext: "Création, refonte ou Ads"
};

export const footerData = {
  company: {
    name: "LM Digital",
    description: "Création de sites web et stratégie digitale pour TPE/PME. Des sites qui convertissent, avant de penser aux Ads.",
    tagline: "Sites web • Conversion • Performance"
  },
  contact: {
    email: "contact@lmdigital.fr"
  },
  legal: [
    { name: "Mentions légales", href: "#" },
    { name: "Politique de confidentialité", href: "#" }
  ],
  social: [
    { name: "LinkedIn", href: "#", icon: "Linkedin" }
  ],
  cta: "Planifier un échange stratégique"
};

export const calendlyConfig = {
  url: "https://calendly.com/louismn31190/solution?hide_gdpr_banner=1&background_color=ffffff&text_color=0f172a&primary_color=1e40af"
};
